import { hasInternshipPermissions } from './hasInternshipPermissions'
import { hasInternshipDirectionPermissions } from './hasInternshipDirectionPermissions'
import { hasRole } from './hasRole'

export const grantAccess = ({
  user,
  roles,
  canUseInternshipPermission,
  isInternshipDirector,
}) => {
  if (hasRole(user, roles)) {
    return true
  }
  if (canUseInternshipPermission && hasInternshipPermissions({ user })) {
    return true
  }
  if (isInternshipDirector && hasInternshipDirectionPermissions({ user })) {
    return true
  }

  return false
}
